import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of, firstValueFrom } from "rxjs";
import { UserService } from "app/core/user/user.service";
import { UserAuthGetter } from "app/core/api-urls/api-url-setters";
import { SessionStorageService } from "app/core/common/sessionStorage.service";
import { Router } from "@angular/router";
import { SnackBarService } from "app/core/common/snackbar.service";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class UserAuthService {
  private _authenticated: boolean = false;

  constructor(
    private _httpClient: HttpClient,
    private _userService: UserService,
    private sessionStorage: SessionStorageService,
    private userAuthGetter: UserAuthGetter,
    private snackBar: SnackBarService,
    private router: Router // Add Router for navigation

  ) {}
  redirectToLogin(): void {
    this.router.navigate(['/sign-in']); // Replace '/sign-in' with the correct route to your login page
  }

  set accessToken(token: string) {
    this.sessionStorage.setItem("accessToken", token);
  }

  get accessToken(): string {
    return this.sessionStorage.getItem<string>("accessToken") ?? "";
  }

  set user(userData: any) {
    this.sessionStorage.setItem("user", userData);
    this._userService.user = userData;
  }

  get user(): any {
    return this.sessionStorage.getItem<any>("user") ?? "";
  }

  async signIn(credentials: any): Promise<any> {
    if (this._authenticated) {
      this.snackBar.onShow("User is already logged in.", "fail");
      throw new Error("User is already logged in.");
    }

    try {
      const httpUrl = this.userAuthGetter.authUserUrl();
      const response = await firstValueFrom(
        this._httpClient.post<any>(httpUrl, credentials, httpOptions)
      );

      if (response.isSuccessful) {
        this.accessToken = response.data.accessToken;
        this.user = response.data.userData;
        this._authenticated = true;
        this._userService.user = response.data.userData;
      } else {
        throw new Error(response.message || "Login failed");
      }

      return response;
    } catch (error) {
      this.snackBar.onShow(error.message || "Login failed", "fail");
      throw error;
    }
  }


  signOut(): Observable<any> {
    this.sessionStorage.removeItem("user");
    this.sessionStorage.removeItem("accessToken");
    this._authenticated = false;
    return of(true);
  }

  check(): Observable<boolean> {
    if (this._authenticated) return of(true);
    if (this.accessToken) return of(true);
    return of(false);
  }

  async savePassword(obj): Promise<any> {
    const httpUrl = this.userAuthGetter.savePasswordUrl();
    return await firstValueFrom(
      this._httpClient.post<any>(httpUrl, obj, httpOptions)
    );
  }

  async confirmOtp(obj): Promise<any> {
    const httpUrl = this.userAuthGetter.confirmOtpUrl();
    return await firstValueFrom(
      this._httpClient.post<any>(httpUrl, obj, httpOptions)
    );
  }

  async getOtp(obj): Promise<any> {
    const httpUrl = this.userAuthGetter.getOtpUrl();
    return await firstValueFrom(
      this._httpClient.post<any>(httpUrl, obj, httpOptions)
    );
  }

  async checkUser(obj): Promise<any> {
    const httpUrl = this.userAuthGetter.checkUserUrl();
    return await firstValueFrom(
      this._httpClient.post<any>(httpUrl, obj, httpOptions)
    );
  }
}
